import { render, staticRenderFns } from "./SearchBarAutocomplete.vue?vue&type=template&id=2987d2c2&scoped=true&"
import script from "./SearchBarAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SearchBarAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./SearchBarAutocomplete.vue?vue&type=style&index=0&id=2987d2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987d2c2",
  null
  
)

export default component.exports